import { useQuery } from '@tanstack/react-query';
import { api } from 'constants/api';

import { useAuthStoreActions } from 'store/AuthStore';
import { useUserStoreActions } from 'store/UserStore';
import { ApiResponse } from 'types/utils/api-response';
import { QueryOptions } from 'types/utils/query-options';
import { UserDetails } from './useGetUserDetail';

export type CurrentUserDetailResponseType = UserDetails;

export const useGetCurrentUser = (
  options: QueryOptions<CurrentUserDetailResponseType> = {}
) => {
  const { setUserDetail } = useUserStoreActions();
  const { setLoggedIn } = useAuthStoreActions();

  return useQuery({
    queryFn: async (): Promise<CurrentUserDetailResponseType> => {
      const { data } =
        await api.get<ApiResponse<CurrentUserDetailResponseType>>(
          `/user/current`
        );

      const userData = data.data;

      setUserDetail(userData);
      setLoggedIn(true);

      return userData;
    },
    queryKey: ['user', 'current'],
    ...options,
  });
};
